import {gql} from '@apollo/client'

export const GET_ALL_CARRIERS = gql`
  query allInsuranceOperators(
    $offset: Int
    $after: String
    $first: Int
    $name: String
    $enabled: Boolean
  ) {
    allInsuranceOperators(
      offset: $offset
      after: $after
      first: $first
      name: $name
      enabled: $enabled
    ) {
      totalCount
      pageInfo {
        hasNextPage
      }
      edges {
        node {
          id
          name
          created
          updated
          policyInsuranceThroughSet {
            edges {
              node {
                id
              }
            }
          }
          policies {
            edges {
              node {
                id
              }
            }
          }
        }
      }
    }
  }
`

export const GET_ALL_INSURANCE_OPERATORS_LIST = gql`
  query allInsuranceOperators(
    $offset: Int
    $after: String
    $first: Int
    $name: String
    $enabled: Boolean
  ) {
    allInsuranceOperators(
      offset: $offset
      after: $after
      first: $first
      name: $name
      enabled: $enabled
    ) {
      totalCount
      pageInfo {
        hasNextPage
      }
      edges {
        node {
          id
          name
          created
          updated
        }
      }
    }
  }
`

export const GET_ALL_CARRIERS_LIST = gql`
  query allInsuranceOperatorsList {
    allInsuranceOperatorsList {
      id
      name
      created
      updated
      category {
        id
        name
      }
    }
  }
`

export const GET_ALL_CARRIERS_WITH_STATUS_LIST = gql`
  query allInsuranceOperatorsWithStatus($status: String, $first: Int, $name: String) {
    allInsuranceOperators(status: $status, first: $first, name: $name) {
      edges {
        node {
          id
          name
          enabled
          created
          updated
        }
      }
    }
  }
`

export const GET_ONE_CARRIER = gql`
  query insuranceOperatorById($id: String) {
    insuranceOperatorById(id: $id) {
      id
      name
      created
      updated
    }
  }
`

export const GET_COMISSIONS_RATE_BY_OPERATOR = gql`
  query commissionRateFiltered($carrierId: ID) {
    commissionRateFiltered(carrierId: $carrierId) {
      id
      created
      rateNew
      rateRenew
      carrier {
        id
        name
      }
      stateEU {
        name
        id
      }
    }
  }
`

export const GET_COMISSIONS_ID = gql`
  query commissionsByOperatorId($operatorId: String) {
    commissionsByOperatorId(operatorId: $operatorId) {
      id
      created
      percentageValue
      nominalValue
      state {
        id
        name
      }
      policyType {
        id
        typePolicy
      }
    }
  }
`

export const GET_CARRIER_CATEGORY = gql`
  query allInsuranceCategory {
    allInsuranceCategory {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`
